import {
  GameType,
  getMachinesByMachineUuidGamesOptions,
} from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";

export type UseGamesFromMachineParams = {
  machineUuid?: string;
  gameType?: GameType | null;
  startTime?: number;
  endTime?: number;
  enabled?: boolean;
};

export function useGamesFromMachine({
  machineUuid,
  gameType = null,
  startTime,
  endTime,
  enabled,
}: UseGamesFromMachineParams) {
  const { data, isLoading, error } = useQuery({
    ...getMachinesByMachineUuidGamesOptions({
      path: { machine_uuid: machineUuid ?? "" },
      query: {
        gameType: gameType ?? undefined,
        startTime: startTime,
        endTime: endTime,
      },
    }),
    enabled: enabled ?? !!machineUuid,
  });

  return {
    games: data?.games ?? [],
    isLoading,
    error,
  } as const;
}
